"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "brennero": {
    "03d44bc8": [{
      "hkey": "519647dc",
      "slug": "fleres-di-dentro",
      "name": "Fleres di Dentro",
      "primary": true,
      "skipSearch": false
    }],
    "fleres": [{
      "hkey": "519647dc",
      "slug": "fleres-di-dentro",
      "name": "Fleres di Dentro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "304b2e26": [{
      "hkey": "28440939",
      "slug": "brennero",
      "name": "Brennero",
      "primary": true,
      "skipSearch": false
    }],
    "ponticolo": [{
      "hkey": "28440939",
      "slug": "brennero",
      "name": "Brennero",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;